export default "__VITE_ASSET__DzKZcGGA__"